import { apiPost } from "./apiClient";

// Not yet implemented server-side — see FUTURE_TASKS.md in uzd_srm_backend
// ("POST /query_parts/price-history — supplier price history lookup").
// Resolves {} (not a rejection) on any failure, including 404, so callers
// can treat "no history" and "endpoint doesn't exist yet" identically —
// this is a convenience layer, never something that should block query
// creation or pricing.
export function fetchPartHistoryQuotes({ makeId, modelId, parts, year, countrySpec, excludeQueryPk }) {
  return apiPost("/query_parts/price-history", {
    make_id: makeId,
    model_id: modelId ?? null,
    parts,
    year: year ?? null,
    country_spec: countrySpec ?? null,
    exclude_query_pk: excludeQueryPk ?? null,
  }).then(res => (res.data?.success ? (res.data.data ?? {}) : {}))
    .catch(() => ({}));
}
